import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: nlsve
 * id ED822193-44D0-481D-B373-F99518240597
 * name bullhorn-variant
 * version: 6.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bullhorn-variant.svg
 * tags
 */
export const BullhornVariantIcon = createSvgIcon(<><path d="M20 2V4L4 8V6H2V18H4V16L6 16.5V18.5C6 20.4 7.6 22 9.5 22S13 20.4 13 18.5V18.3L20 20V22H22V2H20M11 18.5C11 19.3 10.3 20 9.5 20S8 19.3 8 18.5V17L11 17.8V18.5Z" /></>, 'BullhornVariantIcon');
export default BullhornVariantIcon